import { Component, EventEmitter, HostBinding, inject, Input, OnInit, Output } from '@angular/core';
import { ProjectNavigationModel } from '@project-navigation/project-navigation.model';
import { ProjectNavigationService } from '@project-navigation/service/project-navigation.service';
import { ProjectGroupUtils } from '@project/components/project/util/project-group-utils';
import { ProjectGroupVO } from '@project/model/vo/project-group.vo';
import { Log } from '@shared/debug/log';


@Component({
  standalone: false,
  selector: 'app-select-project-group',
  templateUrl: './select-project-group.component.html',
})
export class SelectProjectGroupComponent implements OnInit {
  private readonly projectNavigationService = inject(ProjectNavigationService);

  @Input() complexArticleMode = false;
  @Output() public finish = new EventEmitter<ProjectGroupVO | undefined>();

  @HostBinding(`class.d-flex`) displayFlexClass = true;
  @HostBinding(`class.flex-column`) flexDirectionClass = true;

  public model: ProjectNavigationModel;

  public submitEnabled = false;

  public constructor(
  ) {
    this.model = new ProjectNavigationModel();
    this.model.canNavigateIntoProjectGroups = false;
    this.model.currentModel = {
      visibleSharedProjects: true,
      visibleHiddenProjects: true,
    };
  }

  public ngOnInit(): void {
    if(this.complexArticleMode) {
      this.model.compositeCheckBoxValue = true;
      this.projectNavigationService.triggerCompositeCheckBoxChanged();
    }

    this.projectNavigationService.openPreselectedProjectGroup(this.model);
  }

  public updateSubmitEnabled(): void {
    this.submitEnabled = this.isNormalProjectGroup();
  }

  public async submit(): Promise<void> {
    if(Log.assert(this.isNormalProjectGroup())) {
      this.finish.emit(this.model.currentSelectedItem as ProjectGroupVO);
    }
  }

  private isNormalProjectGroup() {
    return (this.model.currentSelectedItem as ProjectGroupVO)?.groupType == ProjectGroupUtils.PROJECT;
  }

  public cancel(): void {
    this.finish.emit(undefined);
  }
}
